import { Button } from "$components/button/button";
import { styled } from "@material-ui/core";
import { FormattedMessage } from "react-intl";

const Outer = styled("div")(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: theme.spacing(1, 2),
  width: "100%",
}));

// Right-aligned button group; `marginLeft: auto` keeps it trailing on wide
// screens and lets it wrap to its own line on narrow ones.
const Actions = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  marginLeft: "auto",
}));

type Props = {
  onAcknowledge: () => void;
  onGoBack: () => void;
  acknowledging: boolean;
};

export const PriceListReviewModeBar: FC<Props> = ({
  onAcknowledge,
  onGoBack,
  acknowledging,
}) => {
  return (
    <Outer data-testid="priceList.reviewMode.bar">
      <Actions>
        <Button
          variant="outlined"
          color="primary"
          onClick={onGoBack}
          disabled={acknowledging}
          data-testid="priceList.reviewMode.goBack"
        >
          <FormattedMessage
            id="priceList.reviewMode.goBack"
            defaultMessage="Go back"
          />
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onAcknowledge}
          loading={acknowledging}
          disabled={acknowledging}
          data-testid="priceList.reviewMode.acknowledge"
        >
          <FormattedMessage
            id="priceList.reviewMode.acknowledge"
            defaultMessage="Acknowledge"
          />
        </Button>
      </Actions>
    </Outer>
  );
};
